export const CLOSED_INVOICE_STATUS = [
  'PENDENTE',
  'AGENDADO',
  'NAO_AUTORIZADO',
  'NAO_COMPENSADO',
  'CANCELADO',
  'COMPENSADO',
  'AUTORIZADO',
  'ATRASO'
]

export const OPEN_INVOICE_ID = '0'

export const isOpenInvoice = ({ faturaId, status, situacao } = {}) => {
  if (String(faturaId) === OPEN_INVOICE_ID) return true
  if (situacao === 'ABERTA') return true
  return !CLOSED_INVOICE_STATUS.includes(status)
}
